import TeamsPageNameCell from 'pages/Teams/Cells/NameCell';
import type { ManagedDepotsType } from '../..';

interface CellProps {
  rowData: ManagedDepotsType;
}

export default function TeamNameCell({ rowData: { sentinelTeam } }: CellProps) {
  return (
    <TeamsPageNameCell
      hideLogo
      rowData={{
        id: sentinelTeam?.id,
        name: sentinelTeam?.name,
      }}
      openInNewTab
    />
  );
}
